// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__XZNjo {
  width: 150px;
  position: relative;
  background: linear-gradient(to right, #ff136d, #453fd6);
  padding: 1px;
  border-radius: 16px;
}

.styles_button__5W8PF {
  padding: 11px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background-color: #100f0f;
  opacity: 1;
  transition: 0.8s;
  line-height: unset;
}
.styles_button__5W8PF:hover {
  transition: 0.8s;
  opacity: 0.93;
}

.styles_text__OCo0A {
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.9);
}`, "",{"version":3,"sources":["webpack://./src/components/ui/button/buyButton/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,kBAAA;EACA,uDAAA;EACA,YAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBCCS;EDAT,UAAA;EACA,gBAAA;EACA,kBAAA;AADF;AAGE;EACE,gBAAA;EACA,aAAA;AADJ;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BC3BS;ADyBX","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.wrapper {\n  width: 150px;\n  position: relative;\n  background: linear-gradient(to right, #ff136d, #453fd6);\n  padding: 1px;\n  border-radius: 16px;\n}\n\n.button {\n  padding: 11px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  width: 100%;\n  height: 100%;\n  border-radius: 16px;\n  background-color: $black-bg;\n  opacity: 1;\n  transition: 0.8s;\n  line-height: unset;\n\n  &:hover {\n    transition: 0.8s;\n    opacity: 0.93;\n  }\n}\n\n.text {\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-90;\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__XZNjo`,
	"button": `styles_button__5W8PF`,
	"text": `styles_text__OCo0A`
};
export default ___CSS_LOADER_EXPORT___;
